module.exports = __webpack_public_path__ + "media/images/matchingtop-406646a67c7f26bd6f8d45b1bbf445e4.png";